import { Type } from 'class-transformer';
import { BaseEntity } from './base-entity.class';

export abstract class BaseEntityWithSoftDelete extends BaseEntity {
	@Type(() => Date)
	deletedAt?: Date;
}
